import { render, staticRenderFns } from "./organization-unit-role-panel.vue?vue&type=template&id=18b61e6c&scoped=true&"
import script from "./organization-unit-role-panel.vue?vue&type=script&lang=js&"
export * from "./organization-unit-role-panel.vue?vue&type=script&lang=js&"
import style0 from "./organization-unit-role-panel.vue?vue&type=style&index=0&id=18b61e6c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b61e6c",
  null
  
)

export default component.exports